module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0013_12_C18_3.fea1e89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0013_12_C18_3.jpg
// module id = LH5i
// module chunks = 0